"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _data = require("../helpers/data");

var _events = require("../helpers/events");

var _dom = require("../helpers/dom");

var _style = require("../helpers/style");

var _variables = _interopRequireDefault(require("../variables"));

var _is_js = _interopRequireDefault(require("is_js"));

var ModalController = /*#__PURE__*/function () {
  function ModalController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, ModalController);
    this.defaults = {
      modalsSelector: '.page__modal',
      openTrigger: 'data-modal-open',
      closeTrigger: 'data-modal-close',
      activeClass: 'is-active',
      overlap: false
    };
    this.options = _data.$data.deepAssign(this.defaults, options);
    this.activeModal = null;
    this.opened = [];
    this.overlap = this.options.overlap;
    this.bindingEvents();
  }

  (0, _createClass2["default"])(ModalController, [{
    key: "_checkChangeStateCallback",
    value: function _checkChangeStateCallback(cbObj, callbackName, payload) {
      if (_is_js["default"].object(cbObj) && _is_js["default"]["function"](cbObj[callbackName])) cbObj[callbackName](payload);
    }
  }, {
    key: "_change",
    value: function _change(action, modal, callbacks) {
      var _this = this;

      switch (action) {
        case 'show':
          _dom.$dom.addClass(modal, this.options.activeClass);

          _style.$style.set(modal, 'display', 'block');

          _dom.$dom.attr(modal, 'aria-hidden', 'false');

          this.opened.push(modal);

          this._checkChangeStateCallback(callbacks, 'onStart', modal);

          _events.$events.emit(_variables["default"].customEventNames.modal.open, modal, {
            modal: modal
          }).add('animationend', modal, function () {
            _events.$events.emit(_variables["default"].customEventNames.modal.opened, modal, {
              modal: modal
            });

            _this._checkChangeStateCallback(callbacks, 'onEnd', modal);
          }, {
            once: true
          });

          break;

        case 'hide':
          _dom.$dom.attr(modal, 'aria-hidden', 'true');

          this._checkChangeStateCallback(callbacks, 'onStart', modal);

          _events.$events.emit(_variables["default"].customEventNames.modal.close, modal, {
            modal: modal
          }).add('animationend', modal, function () {
            _dom.$dom.removeClass(modal, _this.options.activeClass);

            _style.$style.set(modal, 'display', 'none');

            _events.$events.emit(_variables["default"].customEventNames.modal.closed, modal, {
              modal: modal
            });

            _this._checkChangeStateCallback(callbacks, 'onEnd', modal);
          }, {
            once: true
          });

          this.opened = this.opened.filter(function (item) {
            return item !== modal;
          });
          break;
      }
    }
  }, {
    key: "open",
    value: function open(modalId) {
      var _this2 = this;

      var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.activeModal = _dom.$dom.get('#' + modalId);
      if (this.opened.length > 0 && !this.overlap) this._change('hide', this.opened[0], callbacks);

      this._change('show', this.activeModal, callbacks);

      if (this.opened.length > 1 && this.overlap) {
        var activeModals = _dom.$dom.getAll(this.options.modalsSelector).filter(function (modal) {
          return _dom.$dom.hasClass(modal, _this2.options.activeClass) && modal !== _this2.activeModal;
        });

        _dom.$dom.insertAfter(this.activeModal, activeModals[activeModals.length - 1]);
      }
    }
  }, {
    key: "close",
    value: function close(callbacks) {
      if (this.opened.length > 0) {
        if (this.opened.length > 1) {
          this.activeModal = this.opened[this.opened.length - 1];
        } else if (this.opened.length === 1) {
          this.activeModal = this.opened[0];
        }

        this._change('hide', this.activeModal, callbacks);
      }
    }
  }, {
    key: "bindingEvents",
    value: function bindingEvents() {
      var _this3 = this;

      var openSelector = "[".concat(this.options.openTrigger, "]"),
          closeSelector = "[".concat(this.options.closeTrigger, "]"),
          $self = this;

      _events.$events.delegate.on('click tap', openSelector, function () {
        $self.open(_dom.$dom.attr(this, $self.options.openTrigger));
      }).on('click tap', closeSelector, this.close.bind(this)).on('keyup', document, function (event) {
        if (_this3.opened.length > 0 && event.key.toLowerCase().includes('esc')) _this3.close();
      });

      return this;
    }
  }]);
  return ModalController;
}();

exports["default"] = ModalController;